// Disabling import config as it eslint is unable to tell that it is coming from webpack externals.
// eslint-disable-next-line import/no-unresolved
import config from 'config';
import axiosApi from './axiosApi';
import { setScenes } from '../redux_stores/scenesReducer/actions';
import { setComponentConfig } from '../redux_stores/componentConfigReducer/actions';
import { setStoreData } from '../redux_stores/storeDataReducer/actions';
import { setDefaultIcons } from '../redux_stores/defaultIconsReducer/actions';
import { initializeStoreAvatars } from '../redux_stores/storeAvatarsReducer/actions';
import axios from 'axios';
import { generateRandomString } from '@wsc/utils/urlHelpers';

const reqCacheOptions = {
	ttl: 1000 * 60 * 15,
	interpretHeader: false,
	methods: ['get'],
	cachePredicate: {
		statusCheck: (status) => status >= 200 && status < 400,
	},
};

export const getStoreData = (storeId) => (dispatch) =>
	axiosApi
		.get(`${config.API_URL}/v1/store-with-id?id=${storeId}`)
		.then((res) =>
			dispatch(
				setStoreData({
					...res.data,
					loaded: true,
				}),
			),
		)
		.catch((err) => Promise.reject(err.response));

export const getAllScenes = (storeId) => (dispatch) =>
	axiosApi
		.get(`${config.API_URL}/v1/scene/all?id=${storeId}`)
		.then((res) => {
			dispatch(setScenes(res.data));
		})
		.catch((err) => Promise.reject(err.response));

export const getSceneObjects = (sceneId, locale, verifyProducts = true) => {
	let prefix = `${config.API_URL}/v2/scene/objects`;

	const requestParams = new URLSearchParams({
		id: sceneId,
	});
	if (locale && locale.length > 0) {
		prefix = `${config.API_URL}/v2/scene/objects-with-locale`;
		requestParams.set('locale', locale);
	}

	if (verifyProducts) {
		requestParams.set('verify_products', verifyProducts);
	}

	return axiosApi
		.get(`${prefix}?${requestParams}`, {
			cache: reqCacheOptions,
		})
		.then((res) => res.data)
		.catch((err) => Promise.reject(err.response));
};

export const getComponentConfigApi = (storeId) => {
	const urlPath = `${config.API_URL}/v2/component_config?storeId=${storeId}`;
	return axiosApi
		.get(urlPath)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err));
};

export const getComponentConfig = (storeId) => (dispatch) => {
	if (config.ENV === 'dev') {
		import('../../configs/components.json').then((result) =>
			dispatch(setComponentConfig(result)),
		);
	} else {
		getComponentConfigApi(storeId)
			.then((data) => dispatch(setComponentConfig(data)))
			.catch((err) => console.error(err));
	}
};

export const getDefaultIcons = () => (dispatch) =>
	axiosApi
		.get(`${config.API_URL}/v1/default_icons`)
		.then((res) => dispatch(setDefaultIcons(res.data)))
		.catch((err) => Promise.reject(err.response));

export const getStoreContentScripts = (storeId) => {
	const urlPath = `${config.API_URL}/v1/contents?storeId=${storeId}`;
	return axiosApi
		.get(urlPath)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err));
};

const shuffleArray = (arr) => {
	const newArr = [...arr];
	for (let i = newArr.length - 1; i > 0; i -= 1) {
		const j = Math.floor(Math.random() * (i + 1));
		[newArr[i], newArr[j]] = [newArr[j], newArr[i]];
	}
	return newArr;
};

export const getStoreAvatars = (storeId) => (dispatch) => {
	const urlPath = `${config.API_URL}/v1/avatars?storeId=${storeId}`;
	return axiosApi
		.get(urlPath)
		.then((res) => dispatch(initializeStoreAvatars(shuffleArray(res.data))))
		.catch((err) => Promise.reject(err));
};

export const saveTemp = (blobData) => {
	const urlPath = `${config.API_URL}/v1/save-temp`;
	const formData = new FormData();
	formData.append('file', blobData);
	formData.append('type', blobData.type);
	return new Promise((resolve, reject) => {
		axios({
			method: 'post',
			url: urlPath,
			data: formData,
			headers: { 'Content-Type': 'multipart/form-data' },
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const saveCampaignData = (storeID, campaignId, data) => {
	const url = `${config.API_URL}/v1/save-campaign-data`;
	const payload = {
		store_id: storeID,
		campaign_id: campaignId,
		data,
	};
	return axiosApi
		.post(url, payload)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err));
};

export const submitForConversion = (blobData) => {
	const urlPath = `${config.API_URL}/v1/convert/submit`;
	const formData = new FormData();
	formData.append('file', blobData);
	formData.append('type', blobData.type);
	return new Promise((resolve, reject) => {
		axios({
			method: 'post',
			url: urlPath,
			data: formData,
			headers: { 'Content-Type': 'multipart/form-data' },
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const getConvertResult = (id) => {
	const urlPath = `${
		config.API_URL
	}/v1/convert/get-result?id=${id}&token=${generateRandomString(7)}`;
	return axiosApi
		.get(urlPath)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err));
};
